import {
  buildChecklistResponseInitialValues,
  buildPreStartChecklistSavePayload,
  hasBlockingPreStartUploads,
  hasPreStartChecklistSaveChanges,
  serializePreStartChecklistResponses
} from "../../JobShiftPreStart/jobShiftPreStartFormUtils";

export const READINESS_QUESTIONS_FORM_NAME = "job_shift_rescue_readiness_questions_form";
export const READINESS_HEADING_KEY = "readiness_checklist_heading";

export const getReadinessChecklist = (readiness = {}) => (
  readiness && readiness.rescue_readiness_questions
    ? readiness.rescue_readiness_questions
    : {}
);

const getReadinessChecklistForForm = (readiness = {}) => {
  const checklist = getReadinessChecklist(readiness);
  return {
    ...checklist,
    prestart_checklist_heading: checklist.prestart_checklist_heading !== undefined
      ? checklist.prestart_checklist_heading : checklist.readiness_checklist_heading,
    prestart_staff_signoff: checklist.prestart_staff_signoff !== undefined
      ? checklist.prestart_staff_signoff : checklist.readiness_staff_signoff
  };
};

export const buildReadinessQuestionsInitialValues = (readiness = {}) => {
  const preStartInitialValues = buildChecklistResponseInitialValues(getReadinessChecklistForForm(readiness));

  const responseValues = { ...preStartInitialValues };
  const readinessHeading = responseValues.prestart_checklist_heading;
  delete responseValues.prestart_checklist_heading;
  delete responseValues.prestart_staff_signoff;

  return {
    ...responseValues,
    readiness_checklist_heading: readinessHeading
  };
};



// The answer contract is shared with Pre-Start, but the Readiness resource is
// deliberately kept at its own boundary so the nested response is never lost.
export const buildReadinessSavePayload = (values = {}, readiness = {}) => {
  const checklist = getReadinessChecklistForForm(readiness);
  const payload = buildPreStartChecklistSavePayload({
    ...values,
    prestart_checklist_heading: values.readiness_checklist_heading,
    prestart_staff_signoff: values.readiness_staff_signoff
  }, checklist);

  if (Object.prototype.hasOwnProperty.call(payload, "prestart_checklist_heading")) {
    payload.readiness_checklist_heading = payload.prestart_checklist_heading;
    delete payload.prestart_checklist_heading;
  }
  if (Object.prototype.hasOwnProperty.call(payload, "prestart_staff_signoff")) {
    payload.readiness_staff_signoff = payload.prestart_staff_signoff;
    delete payload.prestart_staff_signoff;
  }
  return payload;
};

export const hasReadinessSaveChanges = (payload = {}) => {
  return Boolean(
    (Array.isArray(payload.answer_updates) && payload.answer_updates.length > 0)
    || Object.prototype.hasOwnProperty.call(payload, "readiness_checklist_heading")
    || Object.prototype.hasOwnProperty.call(payload, "readiness_staff_signoff")
  );
};

export const hasBlockingReadinessUploads = (values = {}, readiness = {}) => (
  hasBlockingPreStartUploads(values, getReadinessChecklist(readiness))
);

export const serializeReadinessResponses = (values = {}, readiness = {}) => {
  const checklist = getReadinessChecklistForForm(readiness);
  const serializedChecklist = serializePreStartChecklistResponses({
    ...values,
    prestart_checklist_heading: values.readiness_checklist_heading,
    prestart_staff_signoff: values.readiness_staff_signoff
  }, checklist);
  const {
    prestart_checklist_heading: checklistHeading,
    prestart_staff_signoff: signoffHeading,
    ...serialized
  } = serializedChecklist;

  return {
    ...readiness,
    rescue_readiness_questions: {
      ...serialized,
      readiness_checklist_heading: checklistHeading,
      readiness_staff_signoff: signoffHeading
    }
  };
};
